import { Component, OnInit } from '@angular/core';
import { FirebaseListObservable, AngularFireDatabase } from 'angularfire2/database-deprecated';
import { Subscription } from "rxjs/Subscription";
import { Router } from '@angular/router';
import { AngularFirestore } from 'angularfire2/firestore';
import { Observable } from 'rxjs';

@Component({
  selector: 'messages-notification',
  templateUrl: './messages-notification.component.html',
  styleUrls: ['./messages-notification.component.css']
})
export class MessagesNotificationComponent implements OnInit {

  public subscription: Subscription;
  messagesNotifications: Observable<any[]>;
  unseenNotifications: Observable<any[]>;

  currentUserId: string;
  constructor(private afs: AngularFirestore, private router: Router) {
    this.currentUserId = localStorage.getItem('currentUserId');



    this.messagesNotifications = this.afs.collection('users').doc(this.currentUserId)
      .collection('messagesNotifications').valueChanges();
    this.unseenNotifications = this.afs.collection('users').doc(this.currentUserId)
      .collection('messagesNotifications', ref => ref.where('isUnseen', '==', true)).valueChanges();






  }
  ngOnInit() {

  }
  seeNotif(key, chatkey) {
    this.afs.collection('users').doc(this.currentUserId).collection('messagesNotifications').doc(key).delete();
    this.router.navigate(['/messages'], { queryParams: { message: chatkey } });
  }
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/messages-notification/messages-notification.component.ts